import { Component, OnInit } from '@angular/core';
import { UserService } from 'src/app/core/services/user.service';
import Swal from 'sweetalert2';
import { Router,ActivatedRoute } from '@angular/router';
import { BaseService } from 'src/app/core/services/base.service';
import { Config } from 'src/app/config/constants';
import { DatePipe } from '@angular/common';
@Component({
  selector: 'app-saved-quotes',
  templateUrl: './saved-quotes.component.html',
  styleUrls: ['./saved-quotes.component.scss'],
  providers: [DatePipe],
})
export class SavedQuotesComponent implements OnInit {

  filterModal:boolean=false;
  isMenuOpen:boolean=false;
  noti: boolean = false;
  drop: boolean = false;
  showSummary:boolean=true;
  showExpiryDate:boolean=true;
  showDateSaved:boolean=true;
  showDepartureDate:boolean=true;
  showDiscription:boolean=true;
  showName:boolean=true;
  showAgentName:boolean=false;
  showQuoteNumber:boolean=true;
  showStatus:boolean=true;
  agencyCode: any;
  agentId: any;
  hideQuotePurchase:any;
  savedQuoteSearchString:any;
  agentIdsaveQuote: any;
  departureEndDate= null;
  departureStartDate= null;
  dateSavedEndDate= null;
  dateSavedStartDate= null;
  firstName= null;
  lastName= null;
  quoteName:any;
quoteDescription:any;
  isSearchCriteriaAvailabe: boolean;
  sortDataBy:any;
  sortDataType:any;

  onSelectSizePage:any=30;
  p:any=0;
  policyPageNo:any=0;
  saveQuoteTotal: any=0;
  AppliedFilter: boolean=false;
  checkOVRInAgencyCode: any;
  VTCCount: any=0;
  IspCount: any=0;
  leadStatus: any;
  currentTime: string;
  constructor(public user: UserService,public router: Router,private base: BaseService,private datePipe: DatePipe,private config:Config) { }

  ngOnInit(): void {
    this.agencyCode=sessionStorage.getItem('agencyCodeSalesPortal');
    this.agentId=sessionStorage.getItem('agentIdSalesPortal');
    this.agentIdsaveQuote=sessionStorage.getItem('agentIdS');
    this.hideQuotePurchase=sessionStorage.getItem('hideQuotePurchase');
    this.checkOVRInAgencyCode=sessionStorage.getItem('checkOVRInAgencyCode');
    // this.getSavedQuotes(this.agencyCode);
    // this.getAllSavedQuotesByAgentId(this.agentId);
    this.loadSearchDetails();
    this.getDashboard();
  }
  toggleMenu() {
    this.isMenuOpen = !this.isMenuOpen;
  }
  deleteSaveQuote(id){
      Swal.fire({
        title: 'Are you sure?',
        text: "Are you sure you want to delete this quote?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes'
      }).then((result) => {
        if (result.isConfirmed) {
          this.user.deletePolicy(id).pipe().subscribe(
              data => {
                this.isMenuOpen=false;
                Swal.fire('','Quote successfully deleted.','success')
                this.getAllSavedQuotesByAgentId(this.agentId);
              },error=>{},()=>{});
        }
        // else{
        //   this.pdfmodel2 = !this.pdfmodel2;
        // }
      })
  }
  notificationShow() {
    this.noti = !this.noti;
   if (this.noti) {
     this.noti = true;
     this.drop = false;
   }
   else {
     this.noti = false;
   }
  }
  closeFilter(){
    this.filterModal=false
  }
  savedQuotes=[];
  // getSavedQuotes(agencyCode){
  //   this.user.getSavedQuoteByAgencyCode(agencyCode).pipe()
  //   .subscribe(
  //       data => {
  //  this.savedQuotes = data.data.userPolicyDetails;
  //       },error=>{},()=>{});
  // }
  getAllSavedQuotesByAgentId(agentId){
    
    const request = {
      "agentId": agentId,
      "dateSavedEndDate":this.dateSavedEndDate,
      "dateSavedStartDate": this.dateSavedStartDate,
      "departureEndDate": this.departureEndDate,
      "departureStartDate": this.departureStartDate,
      "firstName": this.firstName,
      "lastName": this.lastName,
      "quoteDescription": this.quoteDescription,
      "quoteName": this.quoteName,
      "searchString": this.savedQuoteSearchString
    }
    this.user.getAllSavedQuotesByAgentIdSavedQuote(request,this.policyPageNo,this.onSelectSizePage).pipe()
    .subscribe(
      data => {
   this.savedQuotes = data.data.userPolicyDetails;
        },error=>{},()=>{});
  }
  
  gotoQuotePurchase(data){
    
    
    if(this.showVTCDashboard==false){
      localStorage.removeItem('savedQuotesID');
    localStorage.setItem('ShowSavedQuotes', 'true');
    localStorage.setItem('savedQuotesID', data);
      this.router.navigateByUrl('/dashboard/Quotes-Purchase');
    }
    if(this.showVTCDashboard==true){
      localStorage.removeItem('savedQuotesIDVTC');
      localStorage.setItem('ShowSavedQuotesVTC', 'true');
      localStorage.setItem('savedQuotesIDVTC', data);
    this.router.navigateByUrl('/dashboard/vtc');
  }
  }
  isDisabled: boolean = false;
  goToQuotePurchase(){
      if(this.isDisabled){
        return;
      }
    if(this.hideQuotePurchase!="true"){
      this.router.navigateByUrl('/dashboard/Quotes-Purchase');
    }else{
      Swal.fire("","We require your most up-to-date licenses to allow you to sell. Please upload through 'Documents' option under your Account.","info")
    }
  }
  index:any;
  check(i)
  {
    this.index=i;
  }
  savedEmailTemplate:any;
  savedEmailTemplateName:any;
  savedQuotesID:any;
  sendEmail(id){
    this.user.getpolicyAsQuoteAndPrintEmail(id).pipe().subscribe(
      data => {
        this.savedEmailTemplate=data.data.emailTemplate;
        this.savedEmailTemplateName=data.data.emailName;
        this.savedQuotesID=id;
        this.printPopup=true;
    },error=>{},()=>{});
  }
  emailErrorFlag: boolean=false;
  printPopup: boolean=false;
  email1="";
  onRemoveEmailError(){
    this.emailErrorFlag=false;
    }
  emailNotValid: string="";
  emailCheck(){
  var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  
  
  if (!re.test(this.email1.toLowerCase())){
    this.emailNotValid="Please enter valid Email";
  }else{
    this.emailNotValid="";
  }
  }
  onSendEmail(){
    var flag=true;
    if(this.email1==null || this.email1==""){flag=false}else{flag=true}  
    if(flag==true){
        const request = {
            "email": this.email1,
            "emailName": this.savedEmailTemplateName,
            "emailTemplate": this.savedEmailTemplate,
            "policyId": this.savedQuotesID
          }
          this.base.callPostService(this.config.sendEmailOfSavedQuotes, request).subscribe((data: any) => {
            if(data.status==true){
              this.email1=null;
              this.printPopup=false;
              Swal.fire('',data.message,'success');
            }else{
              Swal.fire('',data.message,'error');
            }
          }, error => {
      
        }, () => { });
    }else{
      Swal.fire('',"Enter Email ID",'error');
    }
  }

  onSearchSavedQuote(SearchString){
    if(SearchString.length>1){
      setTimeout(() => {
       var searchname=SearchString
    setTimeout(() => {
      if(searchname.length==this.savedQuoteSearchString.length){
  this.onSearchSavedQuote1(SearchString)
}
},
    500);
    },
    
    900);
  }
  else{
    this.refreshPage()
  }
}
onSearchSavedQuote1(SearchString){
  const request = {
    "agentId": this.agentIdsaveQuote,
    "dateSavedEndDate":this.dateSavedEndDate,
    "dateSavedStartDate": this.dateSavedStartDate,
    "departureEndDate": this.departureEndDate,
    "departureStartDate": this.departureStartDate,
    "firstName": this.firstName,
    "lastName": this.lastName,
    "quoteDescription": this.quoteDescription,
    "quoteName": this.quoteName,
    "searchString": SearchString
  }
  this.user.getAllSavedQuotesByAgentIdSavedQuote(request,this.policyPageNo,this.onSelectSizePage).pipe()
  .subscribe(
    data => {
    
    this.savedQuotes = data.data.userPolicyDetails;
    this.saveQuoteTotal=data.data.total;
    this.VTCCount=data.data?.vtcCount
              this.IspCount=data.data.total
    sessionStorage.removeItem('policyData')
    sessionStorage.setItem('policyData',JSON.stringify(this.savedQuotes));
  }, error => {

}, () => { });
}
refreshPage(){
  this.AppliedFilter=false
  localStorage.removeItem('searchCriteria');
    localStorage.removeItem('sortBy');
    localStorage.removeItem('sortType');
    this.loadSearchDetails();
}
onclickfilterSavedQuote(){
  this.AppliedFilter=true
  
  this.policyPageNo=0
  this.p=0
  if(this.dateSavedEndDate){
    this.dateSavedEndDate=this.datePipe.transform(this.dateSavedEndDate, "yyyy-MM-dd")
  }else{this.dateSavedEndDate=null}
  if(this.dateSavedStartDate){
    this.dateSavedStartDate=this.datePipe.transform(this.dateSavedStartDate, "yyyy-MM-dd")
  }else{this.dateSavedStartDate=null}
  if(this.departureEndDate){
    this.departureEndDate=this.datePipe.transform(this.departureEndDate, "yyyy-MM-dd")
  }else{this.departureEndDate=null}
  if(this.departureStartDate){
    this.departureStartDate=this.datePipe.transform(this.departureStartDate, "yyyy-MM-dd")
  }else{this.departureStartDate=null}
  if((this.dateSavedEndDate==null && this.dateSavedStartDate!=null)||(this.dateSavedEndDate!=null && this.dateSavedStartDate==null)){
    Swal.fire('','Please Enter Both Dates','error');
    this.filterModal=false
    return;
  }
  else if((this.departureEndDate==null && this.departureStartDate!=null )||(this.departureEndDate!=null && this.departureStartDate==null)){
    Swal.fire('','Please Enter Both Dates','error');
    this.filterModal=false
  }
  if(this.quoteName==""){
    this.quoteName=null
  }
  if(this.quoteDescription==""){
    this.quoteDescription=null
  }
  if(this.firstName==""){
    this.firstName=null
  }
  if(this.lastName==""){
    this.lastName=null
  }
  const request = {
    "agentId": this.agentIdsaveQuote,
    "dateSavedEndDate":this.dateSavedEndDate,
    "dateSavedStartDate": this.dateSavedStartDate,
    "departureEndDate": this.departureEndDate,
    "departureStartDate": this.departureStartDate,
    "firstName": this.firstName,
    "lastName": this.lastName,
    "quoteDescription": this.quoteDescription,
    "quoteName": this.quoteName,
    "searchString": this.savedQuoteSearchString
  }
  if(this.isSearchCriteriaPresent())
  {
//     this.isSearchCriteriaAvailabe = true;
//   this.base.callPostService(this.config.filterSavedQuote, request).subscribe((data: any) => {
//     ////
//     this.filterModal=false
//     this.savedQuotes = data.data.userPolicyDetails;
//     this.saveQuoteTotal=data.data.total
//   }, error => {

// }, () => { });
this.isSearchCriteriaAvailabe = true;
this.user.getAllSavedQuotesByAgentIdSavedQuotepagechange(request,this.policyPageNo,this.onSelectSizePage,null)
.subscribe(
  result => {
    if((result.data.userPolicyDetails as Array<any>).length > 0 ){
      this.filterModal=false
      this.savedQuotes = result.data.userPolicyDetails;
      this.saveQuoteTotal=result.data.total;
      this.VTCCount=result.data?.vtcCount
              this.IspCount=result.data.total
      sessionStorage.removeItem('policyData')
      sessionStorage.setItem('policyData',JSON.stringify(this.savedQuotes));
    }
 },error=>{},()=>{});
}else{
  this.isSearchCriteriaAvailabe = false;
  // this.base.callPostService(this.config.filterSavedQuote, request).subscribe((data: any) => {
  //   ////
    this.user.getAllSavedQuotesByAgentIdSavedQuote(request,this.policyPageNo,this.onSelectSizePage)
      .subscribe((data: any) => {

    this.filterModal=false
    this.savedQuotes = data.data.userPolicyDetails;
    this.saveQuoteTotal=data.data.total
    this.VTCCount=data.data?.vtcCount
              this.IspCount=data.data.total
  }, error => {

}, () => { });
}
localStorage.setItem('searchCriteria',JSON.stringify(request));
}

callDepartureStartDateFunction(){
  this.departureStartDate = this.departureStartDate._d;
  console.log("departureStartDate!!",this.departureStartDate);
}
callDepartureEndDateFunction(){
  this.departureEndDate = this.departureEndDate._d;
  console.log("departureEndDate!!",this.departureEndDate);
}
callApplicationStartDateFunction(){
  this.dateSavedStartDate = this.dateSavedStartDate._d;
  console.log("Applicaion start date!!",this.dateSavedStartDate);
}
callApplicationEndDateFunction(){
  this.dateSavedEndDate = this.dateSavedEndDate._d;
  console.log("Applicaion End date!!",this.dateSavedEndDate);
}



agentIdsaveQuote1=null
public isSearchCriteriaPresent(){

  const searchCriteria = [this.agentIdsaveQuote1,this.dateSavedEndDate,this.dateSavedStartDate,
        this.departureEndDate,
        this.departureStartDate,
        this.firstName,this.lastName]

    return searchCriteria.filter(x=>x != null).length > 0;
}
loadSearchDetails(){
  
  const searchedResult = JSON.parse(localStorage.getItem('searchCriteria'));
  this.sortDataBy=localStorage.getItem("sortBy")
  this.sortDataType=localStorage.getItem("sortType")
  // if(searchedResult === null){
  //   this.showSearchedPolicy = false;
  //   return;
  // }
  
  // this.showSearchedPolicy = true;

  if(searchedResult !== null && searchedResult !=="")
  {
     this.agentIdsaveQuote = this.agentIdsaveQuote;
    this.dateSavedEndDate = searchedResult['dateSavedEndDate'];
    this.dateSavedStartDate = searchedResult['dateSavedStartDate'];
    this.departureEndDate = searchedResult['departureEndDate'];
    this.departureStartDate = searchedResult['departureStartDate'];
    this.firstName = searchedResult['firstName'];
    this.lastName = searchedResult['lastName'];
    this.quoteDescription = searchedResult['quoteDescription'];
    this.quoteName = searchedResult['quoteName'];
    this.savedQuoteSearchString = searchedResult['searchString'];
   
    this.isSearchCriteriaAvailabe = true;
    if(this.sortDataType=="asc"){
      this.onPolicySortAsc(this.sortDataBy);
      return;
    }
    else if(this.sortDataType=="desc"){
      this.onPolicySortDsc(this.sortDataBy);
    }
    else{
      const request = {
        "agentId": this.agentIdsaveQuote,
        "dateSavedEndDate":this.dateSavedEndDate,
        "dateSavedStartDate": this.dateSavedStartDate,
        "departureEndDate": this.departureEndDate,
        "departureStartDate": this.departureStartDate,
        "firstName": this.firstName,
        "lastName": this.lastName,
        "quoteDescription": this.quoteDescription,
        "quoteName": this.quoteName,
        "searchString": this.savedQuoteSearchString
      }
      this.user.getAllSavedQuotesByAgentIdSavedQuote(request,this.policyPageNo,this.onSelectSizePage).pipe()
      .subscribe(
        result => {
          
          if((result.data.userPolicyDetails as Array<any>).length > 0 ){
            this.savedQuotes = result.data.userPolicyDetails;
              this.saveQuoteTotal=result.data.total;
              this.VTCCount=result.data?.vtcCount
              this.IspCount=result.data.total
              sessionStorage.removeItem('policyData')
              sessionStorage.setItem('policyData',JSON.stringify(this.savedQuotes));
          }else{
            this.savedQuotes=[];
            sessionStorage.removeItem('policyData')
            this.saveQuoteTotal=0;
            Swal.fire('','No results found','error');
          }
        },error=>{},()=>{});
  //   this.user.getAllSavedQuotesByAgentId(this.agentId).pipe()
  //   .subscribe(
  //       data => {
  //  this.savedQuotes = data.data.userPolicyDetails;
  //  this.saveQuoteTotal=data.data.total;
  //       },error=>{},()=>{});
    }
  }else
  {
    // this.agentIdsaveQuote=""
    this.dateSavedEndDate=null
    this.dateSavedStartDate=null
    this.departureEndDate=null
     this.departureStartDate=null
     this.firstName=null
     this.lastName=null
    this.quoteDescription=null
     this.quoteName=null
     this.savedQuoteSearchString=null
    this.isSearchCriteriaAvailabe = false;

    const request = {
      "agentId": this.agentIdsaveQuote,
      "dateSavedEndDate":this.dateSavedEndDate,
      "dateSavedStartDate": this.dateSavedStartDate,
      "departureEndDate": this.departureEndDate,
      "departureStartDate": this.departureStartDate,
      "firstName": this.firstName,
      "lastName": this.lastName,
      "quoteDescription": this.quoteDescription,
      "quoteName": this.quoteName,
      "searchString": this.savedQuoteSearchString
    }
    this.user.getAllSavedQuotesByAgentIdSavedQuote(request,this.policyPageNo,this.onSelectSizePage).pipe()
    .subscribe(
      data => {
   this.savedQuotes = data.data.userPolicyDetails;
   this.saveQuoteTotal=data.data.total
   this.VTCCount=data.data?.vtcCount
              this.IspCount=data.data.total
        },error=>{},()=>{});
    localStorage.removeItem('searchCriteria');
    localStorage.removeItem('sortBy');
    localStorage.removeItem('sortType');
  }
}



onPolicySortAsc(sortBy){
  
  // if((this.creditCardNumber1==null ||  this.creditCardNumber1=="") && (this.creditCardNumber2==null ||  this.creditCardNumber2=="")){
  //   this.searchCreditCardNumber=null;
  // }
  // else if((this.creditCardNumber1!=null ||  this.creditCardNumber1!="") && (this.creditCardNumber2==null ||  this.creditCardNumber2=="")){
  //   this.searchCreditCardNumber=this.creditCardNumber1;
  // }
  // else if((this.creditCardNumber2!=null ||  this.creditCardNumber2!="") && (this.creditCardNumber1==null ||  this.creditCardNumber1=="")){
  //   this.searchCreditCardNumber=this.creditCardNumber2;
  // }
  // else if((this.creditCardNumber1!=null ||  this.creditCardNumber1!="") && (this.creditCardNumber2!=null ||  this.creditCardNumber2!="")){
  //   this.searchCreditCardNumber=this.creditCardNumber1+'**********'+this.creditCardNumber2
  // }
  
  const searchedResult = JSON.parse(localStorage.getItem('searchCriteria'));
  this.sortDataBy=localStorage.getItem("sortBy")
  this.sortDataType=localStorage.getItem("sortType")
  // if(searchedResult === null){
  //   this.showSearchedPolicy = false;
  //   return;
  // }
  
  // this.showSearchedPolicy = true;

  // if(searchedResult !== null && searchedResult !=="")
  // {
  const request = {
    "agentId": this.agentIdsaveQuote,
    "dateSavedEndDate":this.dateSavedEndDate,
    "dateSavedStartDate": this.dateSavedStartDate,
    "departureEndDate": this.departureEndDate,
    "departureStartDate": this.departureStartDate,
    "firstName": this.firstName,
    "lastName": this.lastName,
    "quoteDescription": this.quoteDescription,
    "quoteName": this.quoteName,
    "searchString": this.savedQuoteSearchString
  }
  this.user.getSearchResultsavedquoteAsc(request,this.policyPageNo,this.onSelectSizePage,sortBy).pipe()
  .subscribe(
      result => {
        if((result.data.userPolicyDetails as Array<any>).length > 0 ){
          this.savedQuotes = result.data.userPolicyDetails;
          this.saveQuoteTotal=result.data.total;
          this.VTCCount=result.data?.vtcCount
              this.IspCount=result.data.total
          sessionStorage.removeItem('policyData')
          sessionStorage.setItem('policyData',JSON.stringify(this.savedQuotes));
          localStorage.setItem("sortBy",sortBy)
          localStorage.setItem("sortType","asc")
      }
      },error=>{},()=>{});
    // }
  //   else
  // {
  //   this.agentIdsaveQuote==null
  //   this.dateSavedEndDate=null
  //   this.dateSavedStartDate=null
  //   this.departureEndDate=null
  //    this.departureStartDate=null
  //    this.firstName=null
  //    this.lastName=null
  //   this.quoteDescription=null
  //    this.quoteName=null
  //    this.savedQuoteSearchString=null
  //   this.isSearchCriteriaAvailabe = false;

  //   this.user.getAllSavedQuotesByAgentIdAsc(this.agentId,this.policyPageNo,this.onSelectSizePage,sortBy).pipe()
  //   .subscribe(
  //       data => {
  //  this.savedQuotes = data.data.userPolicyDetails;
  //  this.saveQuoteTotal=data.data.total
  //  this.VTCCount=data.data?.vtcCount
  //             this.IspCount=data.data.total
  //       },error=>{},()=>{});
  //   localStorage.removeItem('searchCriteria');
  //   localStorage.removeItem('sortBy');
  //   localStorage.removeItem('sortType');
  // }

}
onPolicySortDsc(sortBy){
  // if((this.creditCardNumber1==null ||  this.creditCardNumber1=="") && (this.creditCardNumber2==null ||  this.creditCardNumber2=="")){
  //   this.searchCreditCardNumber=null;
  // }
  // else if((this.creditCardNumber1!=null ||  this.creditCardNumber1!="") && (this.creditCardNumber2==null ||  this.creditCardNumber2=="")){
  //   this.searchCreditCardNumber=this.creditCardNumber1;
  // }
  // else if((this.creditCardNumber2!=null ||  this.creditCardNumber2!="") && (this.creditCardNumber1==null ||  this.creditCardNumber1=="")){
  //   this.searchCreditCardNumber=this.creditCardNumber2;
  // }
  // else if((this.creditCardNumber1!=null ||  this.creditCardNumber1!="") && (this.creditCardNumber2!=null ||  this.creditCardNumber2!="")){
  //   this.searchCreditCardNumber=this.creditCardNumber1+'**********'+this.creditCardNumber2
  // }
  
  const searchedResult = JSON.parse(localStorage.getItem('searchCriteria'));
  this.sortDataBy=localStorage.getItem("sortBy")
  this.sortDataType=localStorage.getItem("sortType")
  // if(searchedResult === null){
  //   this.showSearchedPolicy = false;
  //   return;
  // }
  
  // this.showSearchedPolicy = true;

  // if(searchedResult !== null && searchedResult !=="")
  // {
  const request = {
    "agentId": this.agentIdsaveQuote,
    "dateSavedEndDate":this.dateSavedEndDate,
    "dateSavedStartDate": this.dateSavedStartDate,
    "departureEndDate": this.departureEndDate,
    "departureStartDate": this.departureStartDate,
    "firstName": this.firstName,
    "lastName": this.lastName,
    "quoteDescription": this.quoteDescription,
    "quoteName": this.quoteName,
    "searchString": this.savedQuoteSearchString
  }
  this.user.getSearchResultsavedquoteDsc(request,this.policyPageNo,this.onSelectSizePage,sortBy).pipe()
  .subscribe(
      result => {
        if((result.data.userPolicyDetails as Array<any>).length > 0 ){
          this.savedQuotes = result.data.userPolicyDetails;
          this.saveQuoteTotal=result.data.total;
          this.VTCCount=result.data?.vtcCount
              this.IspCount=result.data.total
          sessionStorage.removeItem('policyData')
          sessionStorage.setItem('policyData',JSON.stringify(this.savedQuotes));
          localStorage.setItem("sortBy",sortBy)
          localStorage.setItem("sortType","desc")
      }
      },error=>{},()=>{});
  //   }
  //   else
  // {
  //    this.agentIdsaveQuote==null
  //   this.dateSavedEndDate=null
  //   this.dateSavedStartDate=null
  //   this.departureEndDate=null
  //    this.departureStartDate=null
  //    this.firstName=null
  //    this.lastName=null
  //   this.quoteDescription=null
  //    this.quoteName=null
  //    this.savedQuoteSearchString=null
  //   this.isSearchCriteriaAvailabe = false;

  //   this.user.getAllSavedQuotesByAgentIdDsc(this.agentId,this.policyPageNo,this.onSelectSizePage,sortBy).pipe()
  //   .subscribe(
  //       data => {
  //  this.savedQuotes = data.data.userPolicyDetails;
  //  this.saveQuoteTotal=data.data.total
  //  this.VTCCount=data.data?.vtcCount
  //             this.IspCount=data.data.total
  //       },error=>{},()=>{});
  //   localStorage.removeItem('searchCriteria');
  //   localStorage.removeItem('sortBy');
  //   localStorage.removeItem('sortType');
  // }

}

pageChnageDone(data){
  
  this.policyPageNo = data-1;
  // if((this.creditCardNumber1==null ||  this.creditCardNumber1=="") && (this.creditCardNumber2==null ||  this.creditCardNumber2=="")){
  //   this.searchCreditCardNumber=null;
  // }
  // else if((this.creditCardNumber1!=null ||  this.creditCardNumber1!="") && (this.creditCardNumber2==null ||  this.creditCardNumber2=="")){
  //   this.searchCreditCardNumber=this.creditCardNumber1;
  // }
  // else if((this.creditCardNumber2!=null ||  this.creditCardNumber2!="") && (this.creditCardNumber1==null ||  this.creditCardNumber1=="")){
  //   this.searchCreditCardNumber=this.creditCardNumber2;
  // }
  // else if((this.creditCardNumber1!=null ||  this.creditCardNumber1!="") && (this.creditCardNumber2!=null ||  this.creditCardNumber2!="")){
  //   this.searchCreditCardNumber=this.creditCardNumber1+'**********'+this.creditCardNumber2
  // }
  // this.p = data-1;
  const request = {
    // "agentId": this.agentIdsaveQuote,
    "dateSavedEndDate":this.dateSavedEndDate,
    "dateSavedStartDate": this.dateSavedStartDate,
    "departureEndDate": this.departureEndDate,
    "departureStartDate": this.departureStartDate,
    "firstName": this.firstName,
    "lastName": this.lastName,
    "quoteDescription": this.quoteDescription,
    "quoteName": this.quoteName,
    "searchString": this.savedQuoteSearchString
  }
  if(this.isSearchCriteriaPresent())
  {
    this.isSearchCriteriaAvailabe = true;
    this.user.getAllSavedQuotesByAgentIdSavedQuote(request,this.policyPageNo,this.onSelectSizePage,null)
    .subscribe(
      result => {
        if((result.data.userPolicyDetails as Array<any>).length > 0 ){
          this.savedQuotes = result.data.userPolicyDetails;
          this.saveQuoteTotal=result.data.total;
          this.VTCCount=result.data?.vtcCount
              this.IspCount=result.data.total
          sessionStorage.removeItem('policyData')
          sessionStorage.setItem('policyData',JSON.stringify(this.savedQuotes));
        }
     },error=>{},()=>{});
  }else{
    this.isSearchCriteriaAvailabe = false;

    this.user.getAllSavedQuotesByAgentIdSavedQuote(request,this.policyPageNo,this.onSelectSizePage,null)
    .subscribe(
      result => {
        if((result.data.userPolicyDetails as Array<any>).length > 0 ){
            this.savedQuotes = result.data.userPolicyDetails;
            this.saveQuoteTotal=result.data.total;
            this.VTCCount=result.data?.vtcCount
              this.IspCount=result.data.total
            sessionStorage.removeItem('policyData')
            sessionStorage.setItem('policyData',JSON.stringify(this.savedQuotes));
        }
     },error=>{},()=>{});
  }
  localStorage.setItem('searchCriteria',JSON.stringify(request));
}
sendPaymentLink(id,purchaserEmail){
  const now = new Date();
  this.currentTime = now.toString();
  this.currentTime=this.datePipe.transform(this.currentTime, "hh:mm a")
  const request = {
    "email": purchaserEmail,
    "emailName": "",
    "emailTemplate": "",
    "policyId": id,
    "brokerTime":this.currentTime
  }
  this.base.callPostService(this.config.sendPaymentLink, request).subscribe((data: any) => {
    Swal.fire('','The payment link was successfully sent to '+purchaserEmail,'success')
  }, error => {
  }, () => { });
}
showVTCDashboard:boolean=false
newlyUploadedDoc(event){
  
  var checkedvtc = event.target.checked;
  if(checkedvtc==true){
    this.showVTCDashboard=true
    this.callVTCApi()
  }
  else{
    this.showVTCDashboard=false
    this.loadSearchDetails();
  }
}
callVTCApi(){
  this.user.getVtcQuotes(this.agentId,this.policyPageNo,this.onSelectSizePage)
    .subscribe(
      result => {
        
        if((result.data.userPolicyDetails as Array<any>).length > 0 ){
            this.savedQuotes = result.data.userPolicyDetails;
            this.saveQuoteTotal=result.data.total;
            sessionStorage.removeItem('policyData')
            sessionStorage.setItem('policyData',JSON.stringify(this.savedQuotes));
            this.IspCount=result.data?.ispCount
            this.VTCCount=result.data.total
        }
     },error=>{},()=>{});
}
getDashboard() {
  this.user.getDashboardData().pipe()
    .subscribe(
      data => {
        this.leadStatus=data.data.leads.leadStatus;
        if(this.leadStatus == 'Deactivated'){
          this.isDisabled = true;
        } else{
          this.isDisabled = false;
        }
       }, error => {
      }, () => { });
}
}
